import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";

import { environment } from "../../../../environments/environment";
import { UserServiceService } from "../../../services/user-service/user-service.service";
import { ErrorHandlerService } from "../../../services/shared/error-handler.service";
import { LeadsService } from "../../../services/lead-service/lead-service.service";
import { ProjectsService } from "../../../services/projects/projects.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-add-broker",
  templateUrl: "./add-broker.component.html",
  styleUrls: ["./add-broker.component.css"],
})
export class AddBrokerComponent implements OnInit {
  broker_export_url: any;

  add_broker: any = {
    name: "",
    contact_phone: "",
    contact_address: "",
    contact_person: "",
    contact_email: "",
    users: null,
  };

  brokerUploadExcel: FormGroup;
  agents: any;

  mode;
  directors: any;
  managers: any;
  national_id_image: any;
  tax_id_image: any;
  commercial_register_image: any;
  
  commissionInfo: any[] = [];
  projects: Array<any> = [];

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private userService: UserServiceService,
    private leadService: LeadsService,
    private projectService: ProjectsService,
    private fb: FormBuilder,
    private errorHandlerService: ErrorHandlerService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.route.params.subscribe((res) => {
      console.log(res);
      if (res.id) {
        this.mode = "edit";
        const storedSettings =
          JSON.parse(window.localStorage.getItem("edit_broker_settings")) || {};
        this.add_broker = {
          ...JSON.parse(window.localStorage.getItem("edit_broker_settings")),
          ...(storedSettings.managers
            ? { manager: Array.isArray(storedSettings.managers) ? storedSettings.managers.map(m => m.id) : []}
            : { manager: [] }),
          ...(storedSettings.directors
            ? { director: Array.isArray(storedSettings.directors) ? storedSettings.directors.map(d => d.id) : [] }
            : { director: [] }),
          contract_renewal_date: this.formatDateForInput(storedSettings.contract_renewal_date),
          contract_beginning_date: this.formatDateForInput(storedSettings.contract_beginning_date),
          contract_end_date: this.formatDateForInput(storedSettings.contract_end_date),
          commercial_register_expiration_date: this.formatDateForInput(storedSettings.commercial_register_expiration_date),
        };
        console.log(
          JSON.parse(window.localStorage.getItem("edit_broker_settings"))
        );
        if (this.add_broker.target_commissions) {
          this.add_broker.target_commissions.map((commission_item) => {
            console.log('Loading commission item:', commission_item);
            this.commissionInfo.push({
              target_upto: commission_item.target_upto,
              commission: commission_item.commission,
              project_id: commission_item.project_id ? parseInt(commission_item.project_id) : null,
            });
          });
          console.log('Commission info after loading:', this.commissionInfo);
        }
      } else this.mode = "add";
    });
  }

  ngOnInit() {
    this.getDirectors();
    this.getManagers();
    this.getAllAgents();
    this.getProjects();
    this.broker_export_url = `${
      environment.api_base_url
    }brokers/export?token=${window.localStorage.getItem("token")}`;

    this.brokerUploadExcel = this.fb.group({
      file: [null, Validators.required],
    });
  }

  addCommissionInfo() {
    this.commissionInfo.push({
      target_upto: null,
      commission: null,
      project_id: null,
    });
  }

  removeCommissionInfo(index) {
    this.commissionInfo.splice(index, 1);
  }

  trackCommissionInfo(index: number, commissionInfoItemType: string, value) {
    this.commissionInfo[index][commissionInfoItemType] = value;
  }

  receivePhone(event, obj, phone, code, err) {
    this[obj][err] = event.phoneError;
    this[obj][phone] = event.phone;
    this[obj][code] = event.code;
  }

  addCommissionInfoTarget() {
    let target_upto_values = [];
    let commission_values = [];
    let project_id_values = [];
    this.commissionInfo.map((e) => {
      if (e.target_upto) {
        target_upto_values.push(e.target_upto);
      }
      if (e.commission) {
        commission_values.push(e.commission);
      }
      if (e.project_id) {
        project_id_values.push(e.project_id);
      }
    });
    this.add_broker.target_upto = target_upto_values;
    this.add_broker.commission = commission_values;
    this.add_broker.project_id = project_id_values;
  }

  getDirectors() {
    this.leadService.getDirectors().subscribe(
      (data: any) => {
        this.directors = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getManagers() {
    this.leadService.getManagers().subscribe(
      (data: any) => {
        this.managers = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getAllAgents() {
    this.leadService.getAgents().subscribe(
      (data: any) => {
        this.agents = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getProjects() {
    this.projectService.getProjects().subscribe(
      (data: any) => {
        this.projects = data.data;
        console.log('Projects loaded:', this.projects);
        // If we're in edit mode and have commission info, make sure project_id is properly set
        if (this.mode === 'edit' && this.commissionInfo.length > 0) {
          this.commissionInfo.forEach(item => {
            if (item.project_id && typeof item.project_id === 'string') {
              item.project_id = parseInt(item.project_id);
            }
          });
          console.log('Commission info after projects loaded:', this.commissionInfo);
        }
        this.slimLoadingBarService.complete();
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  submitBroker() {
    if (!this.add_broker.name) {
      swal("Please enter Broker Name", "", "error");
      return;
    }
    if (!this.add_broker.name_ar) {
      swal("Please enter Registeration Broker Name", "", "error");
      return;
    }
    if (!this.add_broker.tax_id) {
      swal("Please enter Tax ID", "", "error");
      return;
    }
    if (!this.add_broker.commercial_register) {
      swal("Please enter Commercial Register", "", "error");
      return;
    }
    if (this.add_broker.commission_type == "custom_target") {
      this.addCommissionInfoTarget();
    }
    if (this.mode == "add") {
      this.addBroker();
    } else {
      console.log(this.add_broker);
      let payload: any = {
        name: this.add_broker.name,
        contact_person: this.add_broker.contact_person,
        contact_phone: this.add_broker.contact_phone,
        contact_phone_code: this.add_broker.contact_phone_code,
        contact_email: this.add_broker.contact_email,
        contact_address: this.add_broker.contact_address,
        name_ar: this.add_broker.name_ar,
        owner_name: this.add_broker.owner_name,
        owner_id: this.add_broker.owner_id,
        phone: this.add_broker.phone,
        phone_code: this.add_broker.phone_code,
        commercial_register: this.add_broker.commercial_register,
        commercial_register_expiration_date:
          this.add_broker.commercial_register_expiration_date,
        tax_id: this.add_broker.tax_id,
        contract: this.add_broker.contract,
        contract_status: this.add_broker.contract_status,
        contract_renewal_date: this.add_broker.contract_renewal_date,
        contract_end_date: this.add_broker.contract_end_date,
        contract_beginning_date: this.add_broker.contract_beginning_date,
        commission_rate: this.add_broker.commission_rate,
        manager: this.add_broker.manager,
        director: this.add_broker.director,
        comment: this.add_broker.comment,
        users: this.add_broker.users,
        commission_type: this.add_broker.commission_type,
        target_upto: this.add_broker.target_upto,
        commission: this.add_broker.commission,
        project_id: this.add_broker.project_id,
      };
      if (this.national_id_image)
        payload.national_id_image = this.national_id_image;
      if (this.tax_id_image) payload.tax_id_image = this.tax_id_image;
      if (this.commercial_register_image)
        payload.commercial_register_image = this.commercial_register_image;
      if (payload.commission_type == "default") {
        delete payload.commission_rate;
        delete payload.target_upto;
        delete payload.commission;
      } else if (payload.commission_type == "flat") {
        delete payload.target_upto;
        delete payload.commission;
      } else {
        delete payload.commission_rate;
      }
      this.update_broker(payload);
    }
  }

  update_broker(payload) {
    this.slimLoadingBarService.start();
    const broker_id = this.add_broker.id;
    this.userService.editBroker(broker_id, payload).subscribe(
      (data) => {
        swal("Updated successfully", "", "success");
        this.router.navigateByUrl("/pages/brokers");
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  addBroker() {
    let payload: any = {
      ...this.add_broker,
    };
    if (this.add_broker.commission_type == "custom_target") {
      this.addCommissionInfoTarget();
    }
    if (this.national_id_image)
      payload.national_id_image = this.national_id_image;
    if (this.tax_id_image) payload.tax_id_image = this.tax_id_image;
    if (this.commercial_register_image)
      payload.commercial_register_image = this.commercial_register_image;
    this.slimLoadingBarService.start();
    this.userService.addBroker(payload).subscribe(
      (data) => {
        swal("Added a broker successfully", "", "success");
        this.router.navigateByUrl("/pages/settings/brokers");
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  importBrokersModalOpen() {}

  importBrokersModalClose() {
    // this.createFilesUpload();
    // let inputValue = (<HTMLInputElement>document.getElementById("file")).value;
    // inputValue = '';
  }

  handleBrokerUploadExcel(event) {
    console.log(event);
    console.log(event.target.files);
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      console.log(file);
      reader.onload = () => {
        this.brokerUploadExcel.get("file").setValue({
          file_name: file.name,
          file_value: (reader.result as any as any).split(",")[1],
        });
      };
    }
  }

  uploadBrokerExcelMethod(modal) {
    if (this.brokerUploadExcel.valid) {
      const formValue = this.brokerUploadExcel.value;
      const data = {
        file_name: formValue.file.file_name,
        file: formValue.file.file_value,
      };
      this.slimLoadingBarService.start();
      this.leadService.importBrokers(data).subscribe(
        (reso) => {
          // this.createFilesUpload();
          this.brokerUploadExcel.reset();
          let inputValue = (<HTMLInputElement>(
            document.getElementById("brokerExcelFile")
          )).value;
          inputValue = "";
          modal.close();
          swal("Brokers imported successfully", "", "success");
          this.slimLoadingBarService.complete();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  onContractStatusChange(event) {
    console.log(event);
    if (event !== "Signed By Broker") {
      this.national_id_image = null;
      this.tax_id_image = null;
      this.commercial_register_image = null;
    }
  }

  handleNationalIDImageUpload(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.national_id_image = (reader.result as any).split(",")[1];
      };
    }
  }

  handleTaxIDImageUpload(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.tax_id_image = (reader.result as any).split(",")[1];
      };
    }
  }

  handleCommercialRegisterImageUpload(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.commercial_register_image = (reader.result as any).split(",")[1];
      };
    }
  }

  private formatDateForInput(dateString: string): string {
    if (!dateString) return '';
    return dateString.split(' ')[0];
  }
}



// WEBPACK FOOTER //
// ./src/app/main-settings/brokers/add-broker/add-broker.component.ts